import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './Home';
import CaesarCipher from './pages/CaesarCipher';
import AmazonWorker from './pages/AmazonWorker';
import AniFinder from './pages/AniFinder';
import SplitBill from './pages/SplitBill';
import SwingTheory from './pages/SwingTheory';
import GoodViews from './pages/GoodViews';
import GlobalHorizon from './pages/GlobalHorizon';

function App() {

  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/caesar" element={<CaesarCipher/>}/>
        <Route path="/amazonworker" element={<AmazonWorker/>}/>
        <Route path="/anifinder" element={<AniFinder/>}/>
        <Route path="/splitbill" element={<SplitBill/>}/>
        <Route path="/swingtheory" element={<SwingTheory/>}/>
        <Route path="/goodviews" element={<GoodViews/>}/>
        <Route path="/globalhorizon" element={<GlobalHorizon/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;


